import { render, staticRenderFns } from "./SignTrainingContract.vue?vue&type=template&id=26ad52ff"
import script from "./SignTrainingContract.vue?vue&type=script&lang=ts"
export * from "./SignTrainingContract.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports